export default "* 18a0e73\t 2026-02-13T16:47:30-03:00 ";